import type { CommissionIngestBatchNode, CommissionIngestReviewLine } from "../ingest/types";
import { commissionCampaignFixtures } from "./fixtures";

function campaignForBatch(campaignId: string) {
  const campaign = commissionCampaignFixtures.find((node) => node.id === campaignId);
  if (!campaign) {
    throw new Error(`Missing campaign fixture for ${campaignId}`);
  }

  return {
    id: campaign.id,
    editionYear: campaign.editionYear,
    partner: campaign.partner,
    program: campaign.program
  };
}

export const commissionIngestBatchFixtures: CommissionIngestBatchNode[] = [
  {
    id: "commission-ingest-batch-ready",
    status: "READY",
    linesVersion: 2,
    sourceChecksum: "a1b2c3d4",
    createdAt: "2026-03-15T14:22:00Z",
    campaign: campaignForBatch("commission-campaign-2026-acme")
  },
  {
    id: "commission-ingest-batch-confirmed",
    status: "CONFIRMED",
    linesVersion: 3,
    sourceChecksum: "e5f6a7b8",
    createdAt: "2026-02-01T09:10:00Z",
    campaign: campaignForBatch("commission-campaign-2026-acme")
  },
  {
    id: "commission-ingest-batch-compiling",
    status: "COMPILING",
    linesVersion: 1,
    sourceChecksum: "c9d0e1f2",
    createdAt: "2026-03-16T08:00:00Z",
    campaign: campaignForBatch("commission-campaign-2026-fairway")
  }
];

export const commissionIngestReviewLineFixtures: Record<string, CommissionIngestReviewLine[]> = {
  "commission-ingest-batch-ready": [
    {
      id: "commission-ingest-line-1",
      pgaId: "12345678",
      amountCents: 125000,
      confidence: "ELIGIBLE",
      authorizedFacilityName: "Oak Hills Golf Club",
      issues: []
    },
    {
      id: "commission-ingest-line-2",
      pgaId: "87654321",
      amountCents: 98000,
      confidence: "REVIEW",
      authorizedFacilityName: "Pine Valley Country Club",
      issues: [{ code: "FACILITY_MISMATCH", message: "Facility does not match FAA on file." }]
    },
    {
      id: "commission-ingest-line-3",
      pgaId: "11223344",
      amountCents: 50000,
      confidence: "BLOCKED",
      authorizedFacilityName: null,
      issues: [{ code: "NOT_ENROLLED", message: "Member is not enrolled in this program." }]
    }
  ],
  "commission-ingest-batch-confirmed": [
    {
      id: "commission-ingest-line-confirmed-1",
      pgaId: "12345678",
      amountCents: 200000,
      confidence: "ELIGIBLE",
      authorizedFacilityName: "Oak Hills Golf Club",
      issues: []
    }
  ]
};
